import React, { useState, useEffect } from "react";

export default function RobotRuleGame() {
  /* ---------- Inline Styles ---------- */
  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: "linear-gradient(to right, #FFFDE7, #E3F2FD)",
      margin: 0,
      padding: 0,
    },
    container: {
      maxWidth: 1000,
      margin: "0 auto",
      padding: 40,
      textAlign: "center",
      animation: "fadeIn 1s ease-in",
    },
    h1: {
      fontSize: "2.4rem",
      color: "#4A148C",
      marginBottom: 20,
    },
    bubble: {
      background: "#FFF3E0",
      borderLeft: "8px solid #FFB74D",
      padding: 20,
      borderRadius: 16,
      fontSize: "1.2rem",
      marginBottom: 30,
    },
    scenarioBtn: {
      backgroundColor: "#FFD54F",
      padding: "18px 36px",
      fontSize: "1.3rem",
      color: "#4E342E",
      border: "none",
      borderRadius: 16,
      margin: 15,
      cursor: "pointer",
    },
    nextBtn: {
      backgroundColor: "#81C784",
      padding: "14px 28px",
      fontSize: "1.2rem",
      color: "white",
      border: "none",
      borderRadius: 12,
      marginTop: 30,
      cursor: "pointer",
    },
    ruleBox: {
      background: "#E0F7FA",
      padding: 30,
      borderRadius: 14,
      margin: "30px auto",
      maxWidth: 700,
      textAlign: "left",
    },
    ruleItem: {
      background: "#ffffff",
      border: "2px solid #B2EBF2",
      borderRadius: 12,
      padding: "15px 20px",
      margin: "15px 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "1.1rem",
      boxShadow: "2px 2px 6px rgba(0,0,0,0.1)",
    },
    ruleSelect: {
      flex: 1,
      padding: 10,
      fontSize: "1rem",
      borderRadius: 10,
      backgroundColor: "#FFFDE7",
      border: "1px solid #FFECB3",
      marginLeft: 10,
    },
    robotBox: {
      margin: "30px auto",
      width: 300,
      height: 300,
      backgroundColor: "#FFF3E0",
      borderRadius: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 0 12px rgba(0,0,0,0.2)",
      transition: "all 0.4s ease-in-out",
    },
    robotImg: { width: 220, height: "auto" },
    result: {
      marginTop: 20,
      fontSize: "1.4rem",
      color: "#6A1B9A",
    },
    selectInput: { padding: 10, fontSize: "1.1rem", borderRadius: 10, margin: 15 },
  };

  /* ---------- Data ---------- */
  const outfitImages = {
      cap: 'https://kidsdrawinghub.com/wp-content/uploads/2022/06/robot-coloring-pages.png',
      raincoat: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSymV2z8l0Q9LL_ixCxl58wHnwRIFubUqkGUg&s',
      jacket: 'https://img.freepik.com/free-photo/3d-rendering-cute-robot_23-2151931423.jpg',
      scarf: 'https://static.vecteezy.com/system/resources/previews/053/257/114/non_2x/cute-chat-bot-robot-in-red-scarf-and-with-christmas-tree-shows-thumbs-up-vector.jpg',
      lamp: 'https://static.vecteezy.com/system/resources/previews/055/571/213/non_2x/a-cute-cartoon-robot-with-a-glowing-light-bulb-on-its-head-ideal-for-children-s-books-greeting-cards-and-tech-related-projects-modern-flat-style-with-a-warm-color-palette-free-vector.jpg',
      knife: 'https://thumbs.dreamstime.com/b/cute-robot-chef-cooking-simple-line-art-white-background-flat-icon-generative-ai-illustration-323873954.jpg',
      spoon: 'https://thumbs.dreamstime.com/b/friendly-green-robot-enjoying-healthy-salad-388800604.jpg',
      spatula: 'https://png.pngtree.com/png-clipart/20250517/original/pngtree-robot-chef-cooking-with-frying-pan-illustration-vector-png-image_21015676.png',
      pan: 'https://thumbs.dreamstime.com/b/funny-d-illustration-cute-android-robot-as-chef-carrying-pancakes-frying-pan-ai-assistant-336025037.jpg',
      toaster: 'https://i.pinimg.com/originals/e3/d0/a8/e3d0a8a8d0991cb592ba9f03b30f4d22.gif',
      car: 'https://c7.alamy.com/comp/T5BP4R/illustration-of-a-little-robot-little-robot-riding-car-on-isolated-white-background-T5BP4R.jpg',
      bus: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRY02fxaISlK1xVX-rLJ3CLxYr2UljeCccsVQ&s',
      bike: 'https://thumbs.dreamstime.com/b/futuristic-robot-delivery-rider-electric-bike-tablet-ai-generated-image-showcases-state-art-humanoid-374444657.jpg',
      train: 'https://external-preview.redd.it/robots-on-the-subway-v0-mAAhRP7gIqgbpm-hyIJcUQZpSLGTL5iiVREp_4Bffq4.png?width=640&crop=smart&format=pjpg&auto=webp&s=32254a860b40bb5265acee128f211ba6dfd56464',
      boat: 'https://thumbs.dreamstime.com/b/robot-controlling-boat-water-vector-design-generative-ai-cheerful-calm-illustrating-automation-maritime-activities-ideal-387422567.jpg'
    };

  const labelMaps = {
    weather: {
      sunny: "☀️ Sunny",
      rainy: "🌧️ Rainy",
      snowy: "❄️ Snowy",
      windy: "🌬️ Windy",
      foggy: "🌫️ Foggy",
    },
    kitchen: {
      soup: "🍲 Soup",
      pasta: "🍝 Pasta",
      salad: "🥗 Salad",
      omelet: "🍳 Omelet",
      bread: "🍞 Bread",
    },
    transport: {
      city: "🏙️ City",
      village: "🏡 Village",
      mountain: "⛰️ Mountain",
      bridge: "🌉 Bridge",
      beach: "🏖️ Beach",
    },
  };

  const responseLabels = {
    cap: "a Cap 🧢",
    raincoat: "a Raincoat 🧥",
    jacket: "a Jacket 🧥",
    scarf: "a Scarf 🧣",
    lamp: "a Headlamp 🔦",
    knife: "a Knife 🔪",
    spoon: "a Spoon 🥄",
    pan: "a Pan 🍳",
    spatula: "a Spatula 🍽️",
    toaster: "a Toaster 🔌",
    car: "a Car 🚗",
    bus: "a Bus 🚌",
    bike: "a Bike 🚲",
    train: "a Train 🚆",
    boat: "a Boat 🚤",
  };

  /* ---------- Component State ---------- */
  const [stage, setStage] = useState("select"); // select, build, play
  const [scenario, setScenario] = useState("weather");
  const [rules, setRules] = useState({});
  const [testInput, setTestInput] = useState("");
  const [result, setResult] = useState("");
  const [robotImg, setRobotImg] = useState("https://cdn-icons-png.flaticon.com/512/4712/4712074.png");

  useEffect(() => {
    // Reset when scenario changes
    setRules({});
    setTestInput("");
    setResult("");
    setRobotImg("https://cdn-icons-png.flaticon.com/512/4712/4712074.png");
  }, [scenario]);

  /* ---------- Helpers ---------- */
  const handleRuleChange = (key, value) => {
    setRules((prev) => ({ ...prev, [key]: value }));
  };

  const startGame = () => {
    // simple validation: at least one rule
    if (Object.values(rules).some((v) => v)) {
      setStage("play");
    } else {
      alert("Please set at least one rule to start!");
    }
  };

  const testRobot = () => {
    if (!testInput || !rules[testInput]) {
      setResult("⚠️ Please select an input with a rule.");
      setRobotImg("https://cdn-icons-png.flaticon.com/512/4712/4712074.png");
      return;
    }
    const response = rules[testInput];
    setRobotImg(outfitImages[response]);
    setResult(`✅ It's ${labelMaps[scenario][testInput]} → Robot uses ${responseLabels[response]}`);
  };

  /* ---------- Render ---------- */
  return (
    <div style={styles.body}>
      <div style={styles.container}>
        {/* Stage 1: Scenario Selection */}
        {stage === "select" && (
          <>
            <h1 style={styles.h1}>🤖 Welcome to the Rule-Building World!</h1>
            <div style={styles.bubble}>
              Some robots don’t learn — they just follow instructions we give them. These are called <strong>Rule-Based Systems</strong>.
            </div>
            <div style={styles.bubble}>
              You’ll build rules for different robots in 3 exciting missions:
              <ul style={{ textAlign: "left", maxWidth: 600, margin: "auto" }}>
                <li>🌦 Weather Robot → Dress up based on weather</li>
                <li>🍽 Kitchen Robot → Choose the right kitchen tools</li>
                <li>🚗 Transport Bot → Match the vehicle to the route</li>
              </ul>
            </div>
            <div style={styles.bubble}>Ready to become a robot commander? 🎮 Choose a scenario to begin:</div>
            <div style={{ fontSize: "1.8rem", marginBottom: 10 }}>🌦 🍽 🚗</div>
            <button style={styles.scenarioBtn} onClick={() => { setScenario("weather"); setStage("build"); }}>
              🌦 Weather Robot
            </button>
            <button style={styles.scenarioBtn} onClick={() => { setScenario("kitchen"); setStage("build"); }}>
              🍽 Kitchen Robot
            </button>
            <button style={styles.scenarioBtn} onClick={() => { setScenario("transport"); setStage("build"); }}>
              🚗 Transport Bot
            </button>
          </>
        )}

        {/* Stage 2: Rule Builder */}
        {stage === "build" && (
          <>
            <h1 style={styles.h1}>{scenario === "weather" ? "🌦 Weather Robot" : scenario === "kitchen" ? "🍽 Kitchen Robot" : "🚗 Transport Bot"}</h1>
            <div style={styles.bubble}>
              {scenario === "weather" && "Help your robot decide what to wear for different weather conditions."}
              {scenario === "kitchen" && "Help your robot choose the right tool for each food item."}
              {scenario === "transport" && "Help your bot choose the right vehicle for each place."}
            </div>
            <div style={styles.ruleBox}>
              {Object.keys(labelMaps[scenario]).map((key) => (
                <div key={key} style={styles.ruleItem}>
                  <label style={{ flex: 1 }}>{labelMaps[scenario][key]} →</label>
                  <select
                    style={styles.ruleSelect}
                    value={rules[key] || ""}
                    onChange={(e) => handleRuleChange(key, e.target.value)}
                  >
                    <option value="">-- Select an option --</option>
                    {/* Dynamic options based on scenario */}
                    {scenario === "weather" && (
                      <>
                        {key === "sunny" && (
                          <>
                            <option value="cap">Wear Cap</option>
                            <option value="raincoat">Wear Raincoat</option>
                            <option value="jacket">Wear Jacket</option>
                            <option value="scarf">Wear Scarf</option>
                            <option value="lamp">Turn On Headlamp</option>
                          </>
                        )}
                        {key === "rainy" && (
                          <>
                            <option value="raincoat">Wear Raincoat</option>
                            <option value="cap">Wear Cap</option>
                            <option value="jacket">Wear Jacket</option>
                          </>
                        )}
                        {key === "snowy" && (
                          <>
                            <option value="jacket">Wear Jacket</option>
                            <option value="scarf">Wear Scarf</option>
                          </>
                        )}
                        {key === "windy" && (
                          <>
                            <option value="scarf">Wear Scarf</option>
                            <option value="cap">Wear Cap</option>
                          </>
                        )}
                        {key === "foggy" && (
                          <>
                            <option value="lamp">Turn On Headlamp</option>
                            <option value="jacket">Wear Jacket</option>
                          </>
                        )}
                      </>
                    )}

                    {scenario === "kitchen" && (
                      <>
                        {key === "soup" && (
                          <>
                            <option value="spoon">Use Spoon</option>
                            <option value="pan">Use Pan</option>
                            <option value="knife">Use Knife</option>
                          </>
                        )}
                        {key === "pasta" && (
                          <>
                            <option value="pan">Use Pan</option>
                            <option value="toaster">Use Toaster</option>
                          </>
                        )}
                        {key === "salad" && (
                          <>
                            <option value="knife">Use Knife</option>
                            <option value="spoon">Use Spoon</option>
                          </>
                        )}
                        {key === "omelet" && (
                          <>
                            <option value="spatula">Use Spatula</option>
                            <option value="pan">Use Pan</option>
                          </>
                        )}
                        {key === "bread" && (
                          <>
                            <option value="toaster">Use Toaster</option>
                            <option value="knife">Use Knife</option>
                          </>
                        )}
                      </>
                    )}

                    {scenario === "transport" && (
                      <>
                        {key === "city" && (
                          <>
                            <option value="bus">Take Bus</option>
                            <option value="car">Take Car</option>
                          </>
                        )}
                        {key === "village" && (
                          <>
                            <option value="bike">Take Bike</option>
                            <option value="car">Take Car</option>
                          </>
                        )}
                        {key === "mountain" && (
                          <>
                            <option value="car">Take Car</option>
                            <option value="bike">Take Bike</option>
                          </>
                        )}
                        {key === "bridge" && (
                          <>
                            <option value="train">Take Train</option>
                            <option value="bus">Take Bus</option>
                          </>
                        )}
                        {key === "beach" && (
                          <>
                            <option value="boat">Take Boat</option>
                            <option value="bike">Take Bike</option>
                          </>
                        )}
                      </>
                    )}
                  </select>
                </div>
              ))}
            </div>
            <button style={styles.nextBtn} onClick={startGame}>
              🎮 Start Game
            </button>
          </>
        )}

        {/* Stage 3: Play Game */}
        {stage === "play" && (
          <>
            <h1 style={styles.h1}>🤖 Test the {scenario.charAt(0).toUpperCase() + scenario.slice(1)} Robot!</h1>
            <p>Choose an input — see what your robot does!</p>
            <select
              style={styles.selectInput}
              value={testInput}
              onChange={(e) => setTestInput(e.target.value)}
            >
              <option value="">-- Choose Input --</option>
              {Object.keys(labelMaps[scenario]).map((key) => (
                <option key={key} value={key}>
                  {labelMaps[scenario][key]}
                </option>
              ))}
            </select>
            <button style={styles.nextBtn} onClick={testRobot}>
              Test Robot
            </button>
            <div style={styles.robotBox}>
              <img src={robotImg} alt="Robot" style={styles.robotImg} />
            </div>
            <div style={styles.result}>{result}</div>
            <button style={{ ...styles.nextBtn, backgroundColor: "#FFB74D" }} onClick={() => setStage("select")}>🔄 Restart</button>
          </>
        )}
      </div>
    </div>
  );
}
